import { render } from "./SwitchType.vue?vue&type=template&id=2ee59d17"
import script from "./SwitchType.vue?vue&type=script&lang=js"
export * from "./SwitchType.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__